import React, { useEffect, useRef } from 'react';

const HetznerInstallationSection = () => {
  const installationTypes = [
    {
      title: "Infrastructure Consulting",
subtitle: "Planning & Architecture",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 text-white">
          <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Z" />
        </svg>
      ),
      features: [
"Infrastructure Assessment",
"Cloud Strategy & Planning",
"Cost Optimization Recommendations",
"Scalability & Performance Planning",
"Security Best Practices",
"Technology Selection Guidance",
"Migration Roadmap"
],
      delay: "150ms"
    },
    {
      title: "Cloud Migration & Deployment",
subtitle: "AWS, Azure, GCP, Hetzner & More",

      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 text-white">
          <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 15a4.5 4.5 0 0 0 4.5 4.5H18a3.75 3.75 0 0 0 1.332-7.257 3 3 0 0 0-3.758-3.848 5.25 5.25 0 0 0-10.233 2.33A4.502 4.502 0 0 0 2.25 15Z" />
        </svg>
      ),
      features: [
"Cloud Infrastructure Migration",
"Server Provisioning & Setup",
"Docker & Kubernetes Deployment",
"Database Migration",
"Network & Security Configuration",
"Monitoring & Logging Setup",
"Minimal Downtime Migration"
],
      delay: "250ms"
    },
    {
      title: "Managed Infrastructure Services",
subtitle: "24/7 Monitoring & Support",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 text-white">
          <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 5.25a3 3 0 0 1 3 3m3 0a6 6 0 0 1-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1 1 21.75 8.25Z" />
        </svg>
      ),
      features: [
"24/7 Infrastructure Monitoring",
"Backup & Disaster Recovery",
"Patch Management & Updates",
"Performance Optimization",
"Security Hardening",
"DevOps & Automation",
"Dedicated Technical Support"
],
      delay: "350ms"
    }
  ];

  useEffect(() => {
    // Trigger animations for elements that should animate in
    const animateElements = () => {
      const elements = document.querySelectorAll('.animate-on-scroll');
      elements.forEach(element => {
        const rect = element.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight - 100;
        if (isVisible) {
          element.classList.add('animated');
        }
      });
    };

    // Initial check
    animateElements();

    // Add scroll listener
    window.addEventListener('scroll', animateElements);
    
    return () => {
      window.removeEventListener('scroll', animateElements);
    };
  }, []);

  return (
    <section id="installation" className="py-8 md:py-10 ">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header Section */}
        <div className="text-center mb-12">
          <span className="text-blue-600 font-semibold text-xs uppercase tracking-wider">
            Professional Cloud Infrastructure Services
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mt-2 mb-4">
            Cloud Setup, Migration & Management
          </h2>
          <p className="text-gray-600 text-base max-w-3xl mx-auto">
            Professional infrastructure deployment and management for on-premise, cloud, and hybrid environments.
          </p>
        </div>

        {/* Installation Types Grid */}
        <div className="grid md:grid-cols-3 gap-6 mb-16">
          {installationTypes.map((type, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-6 border border-gray-200 hover:shadow-lg transition-all duration-500 animate-on-scroll"
              style={{ transitionDelay: type.delay }}
            >
              <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-blue-600 rounded-xl mb-4 flex items-center justify-center">
                {type.icon}
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-1">{type.title}</h3>
              <p className="text-sm text-gray-500 mb-4">{type.subtitle}</p>
              <ul className="space-y-2">
                {type.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-2 text-sm text-gray-600">
                    <svg className="w-4 h-4 text-blue-500 mt-0.5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HetznerInstallationSection;